import { gql } from "@apollo/client";

export const ADD_REPORT = gql`
  mutation addReport($input: AddReportInput!) {
    addReport(input: $input) {
      id
    }
  }
`;

export const GET_REPORTS = gql`
  query reports($first: Int, $after: String, $before: String) {
    reports(first: $first, after: $after, before: $before) {
      edges {
        node {
          id
          fileName
          key
          reportUrl
          updatedAt
          status
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        total
      }
    }
  }
`;
